import { z } from 'zod';
import { CoreCommunicationSendAttemptDirectionTypeSchema } from '../inputTypeSchemas/CoreCommunicationSendAttemptDirectionTypeSchema'
import { CoreCommunicationChannelTypeSchema } from '../inputTypeSchemas/CoreCommunicationChannelTypeSchema'
import { CoreCommunicationSendAttemptStatusTypeSchema } from '../inputTypeSchemas/CoreCommunicationSendAttemptStatusTypeSchema'

/////////////////////////////////////////
// CORE COMMUNICATION SEND ATTEMPT SCHEMA
/////////////////////////////////////////

export const CoreCommunicationSendAttemptSchema = z.object({
  direction: CoreCommunicationSendAttemptDirectionTypeSchema,
  channelType: CoreCommunicationChannelTypeSchema,
  status: CoreCommunicationSendAttemptStatusTypeSchema,
  id: z.number().int(),
  cityId: z.number().int(),
  referenceId: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  reasonCode: z.string().nullable(),
  reasonText: z.string().nullable(),
})

export type CoreCommunicationSendAttempt = z.infer<typeof CoreCommunicationSendAttemptSchema>

export default CoreCommunicationSendAttemptSchema;
